import React, { useContext, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "../Firebase/AuthProvider";
import { getGoogleMaps } from "config/GoogleMaps";
import { LinearProgress } from "@material-ui/core";
const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  const { authenticated, loadingAuthState } = useContext(AuthContext);
  useEffect(() => {
    if (!window.google) {
      const googleMapPromise = getGoogleMaps();
      Promise.all([googleMapPromise]);
    }
  }, []);

  if (loadingAuthState) {
    return (
      <div>
        <LinearProgress />
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        authenticated ? (
          <RouteComponent {...routeProps} />
        ) : (
          <Redirect
            to={{ pathname: "/auth/login", state: { prevPath: rest.path } }}
          />
        )
      }
    />
  );
};
export default PrivateRoute;
